import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TableModule } from 'primeng/table';
import { ChartModule } from 'primeng/chart';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { PaginatorModule } from 'primeng/paginator';
import { CheckboxModule } from 'primeng/checkbox';
import { CookieService } from 'ngx-cookie-service';
import { NgxFileDropModule } from 'ngx-file-drop';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { RadioButtonModule } from 'primeng/radiobutton';
import { MenuModule } from 'primeng/menu';
// import {ToggleButtonModule} from 'primeng/togglebutton';
import {InputSwitchModule} from 'primeng/inputswitch';
//import { CaptchaModule } from 'primeng/captcha';
// import {ToastModule} from 'primeng/toast';
import {ProgressBarModule} from 'primeng/progressbar';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import {InputTextareaModule} from 'primeng/inputtextarea';
import { ReCaptchaModule } from '../components/recaptcha/recaptcha.component'
import { VoyageDetailComponent } from "src/app/public/voyage/voyage-detail/voyage-detail.component";
import { VoyageFilterControlsComponent } from "../components/voyage-filter-controls/voyage-filter-controls.component";
import { EditorModule } from 'primeng/editor';

@NgModule({
  declarations:[VoyageFilterControlsComponent],
  imports: [CommonModule, DropdownModule, CalendarModule, ButtonModule, AutoCompleteModule,
    TableModule, ChartModule, MultiSelectModule, FormsModule, AccordionModule, NgxSliderModule, ConfirmDialogModule,
    PaginatorModule, CheckboxModule, NgxFileDropModule, FileUploadModule, TooltipModule, RadioButtonModule,
    MenuModule,InputSwitchModule,ProgressBarModule,PDFExportModule,InputTextareaModule,ReCaptchaModule,
    ReactiveFormsModule,EditorModule],

  exports: [ReactiveFormsModule, DropdownModule, CalendarModule, ButtonModule, AutoCompleteModule,
    TableModule, ChartModule, MultiSelectModule, FormsModule, AccordionModule, NgxSliderModule,
    PaginatorModule, CheckboxModule, NgxFileDropModule, FileUploadModule, TooltipModule, ConfirmDialogModule, RadioButtonModule,
    MenuModule,InputSwitchModule,ProgressBarModule,PDFExportModule,InputTextareaModule,ReCaptchaModule, VoyageFilterControlsComponent,EditorModule],
  providers: [
    CookieService
  ],
})
export class SharedModule {
}
